import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { Text } from '@mxenabled/mxui'
import { PieChart } from '@mui/x-charts/PieChart'
interface DonutSegment {
  color: string
  label?: string
  labelValue?: React.ReactNode
  value: number
}

interface DonutChartV2Props {
  data: DonutSegment[]
  centerLabel?: string
  centerValue: string
}

const DonutChartV2 = ({ data, centerLabel, centerValue }: DonutChartV2Props) => {
  const hasLegend = data.some((segment) => segment.label && segment.labelValue)
  const isEmbedded = !hasLegend

  const chartData = data.map((item, index) => ({
    id: index,
    color: item.color,
    value: item.value,
  }))
  const innerRadius = isEmbedded ? 30 : 53
  const outerRadius = isEmbedded ? 35 : 63
  const cornerRadius = 2

  const getCenterValueVariant = () => {
    if (isEmbedded) return 'body1'
    if (centerLabel) return 'h3'
    return 'h2'
  }

  return (
    <Stack sx={{ alignItems: 'center', flexDirection: 'row', px: 16, py: 4 }}>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
          position: 'relative',
        }}
      >
        <PieChart
          height={isEmbedded ? 72 : 125}
          series={[
            {
              cornerRadius,
              data: chartData,
              innerRadius,
              outerRadius,
            },
          ]}
          slots={{ tooltip: () => null }}
          width={isEmbedded ? 72 : 125}
        />

        <Box sx={{ position: 'absolute', textAlign: 'center' }}>
          <Text sx={{ ...(isEmbedded && { fontWeight: 600 }) }} variant={getCenterValueVariant()}>
            {centerValue}
          </Text>
          {centerLabel && (
            <Text sx={{ color: 'text.secondary' }} variant={isEmbedded ? 'caption' : 'body2'}>
              {centerLabel}
            </Text>
          )}
        </Box>
      </Box>

      {hasLegend && (
        <Stack sx={{ gap: 24, pl: 24 }}>
          {data.map(
            (segment, index) =>
              segment.label &&
              segment.labelValue && (
                <Stack key={segment.label ?? index}>
                  <Stack sx={{ gap: 8, flexDirection: 'row', alignItems: 'center' }}>
                    <Box
                      sx={{
                        backgroundColor: segment.color,
                        borderRadius: '2px',
                        height: 12,
                        width: 12,
                      }}
                    />
                    <Text sx={{ fontWeight: 400 }} variant="subtitle2">
                      {segment.label}
                    </Text>
                  </Stack>
                  <Text sx={{ fontWeight: 400, pl: 20 }} variant="subtitle2">
                    {segment.labelValue}
                  </Text>
                </Stack>
              ),
          )}
        </Stack>
      )}
    </Stack>
  )
}

export default DonutChartV2
